import ReactDOM from 'react-dom';
import React from 'react';
import { LocaleQuestion } from './Widget';

export interface AnswerType {
  lang: string;
  value: string;
}

function init(Survey: any) {
  if (typeof Survey === 'undefined') {
    return undefined;
  }
  const widget = {
    name: 'dtlocale',
    title: 'dt Locale',
    widgetIsLoaded: function () {
      return true;
    },
    isFit: function (question: any) {
      return question.getType() === 'dtlocale';
    },
    isDefaultRender: false,
    activatedByChanged: function () {
      Survey.JsonObject.metaData.addClass('dtlocale', [], null, 'empty');

      Survey.Serializer.addProperties('dtlocale', [
        {
          name: 'avialableLocales',
          default: [],
        },
        {
          name: 'baseLocales',
          default: [],
        },
        {
          name: 'userLang',
          default: null,
        },
      ]);
    },
    htmlTemplate: '<div></div>',
    afterRender: async function (question: any, el: any) {
      ReactDOM.render(<LocaleQuestion question={question} />, el);
    },
  };

  return Survey.CustomWidgetCollection.Instance.addCustomWidget(
    widget,
    'customtype'
  );
}

export default init;
